import { render, staticRenderFns } from "./page23.vue?vue&type=template&id=4c0f8e99&scoped=true&"
import script from "./page23.vue?vue&type=script&lang=js&"
export * from "./page23.vue?vue&type=script&lang=js&"
import style0 from "./page23.vue?vue&type=style&index=0&id=4c0f8e99&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0f8e99",
  null
  
)

export default component.exports